import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Documents, OtherDocumentsByType } from "../../../models/Consultant";
import { otherDocumentTypes } from "../../../utils/document.utils";
import AppText from "../../Core/AppText/AppText";
import Checkbox from "../../Core/Checkbox/Checkbox";
import Flex from "../../Layout/Flex";

type Props = {
	documents?: Documents;
	updateDocuments: Function;
	isCandidate: boolean;
};

/**
 * The "Övriga dokument" checkbox list on the library tab. The Certifieringar
 * section that used to live here (legacy `certificationsByType`) is retired —
 * certificates are managed on the "Certifikat & taggar" tab against the org
 * taxonomy. The stored `certificationsByType` data is deliberately left
 * untouched (still read by the legacy matching path) — updates here spread the
 * existing `documents` so it survives saves unchanged.
 */
const DocumentTypeComponent: React.FC<Props> = ({ documents, updateDocuments }) => {
	const { t } = useTranslation();

	const buildInitialOByType = (): OtherDocumentsByType => {
		const next: OtherDocumentsByType = {};
		otherDocumentTypes.forEach((key) => {
			next[key] = { include: false };
		});
		return next;
	};

	const [otherDocumentsByType, setOtherDocumentsByType] =
		useState<OtherDocumentsByType>(buildInitialOByType);

	useEffect(() => {
		const oByType: OtherDocumentsByType = {};

		otherDocumentTypes.forEach((key) => {
			oByType[key] = { include: false };

			if (documents?.otherDocumentsByType)
				oByType[key].include = !!documents.otherDocumentsByType[key]?.include;
		});

		setOtherDocumentsByType(oByType);
	}, [documents]);

	const handleOtherDocumentCheck = (key: string, e: any) => {
		const oByType = { ...otherDocumentsByType };
		oByType[key].include = e.target.checked;
		setOtherDocumentsByType(oByType);

		updateDocuments({
			...documents,
			otherDocumentsByType: oByType,
		});
	};

	return (
		<Flex margin="50px 15px" maxWidth="1200px">
			<OtherDocumentsWrapper>
				<Flex direction="column">
					<AppText weight="medium" color="grayText" margin="0 0 27px 0">
						{t("OTHER_DOCUMENTS")}
					</AppText>
					{otherDocumentTypes?.map((key) => (
						<Flex key={key} margin="0 0 27px 0">
							<Checkbox
								label={t(key as any)}
								isChecked={otherDocumentsByType[key].include}
								onChange={(e: any) => handleOtherDocumentCheck(key, e)}
							/>
						</Flex>
					))}
				</Flex>
			</OtherDocumentsWrapper>
		</Flex>
	);
};

export default DocumentTypeComponent;

const OtherDocumentsWrapper = styled.div`
	flex: 0 0 auto;
	padding-right: 12%;
`;
